import React from 'react';

import { OverridableComponent } from '@mui/material/OverridableComponent';
import { SvgIconTypeMap } from '@mui/material/SvgIcon';
import { styled as muiStyled } from '@mui/material/styles';

import { Button, PLAYER_BUTTON_SIZE, shadowedIconStyle } from './PlayerButton.style';

interface Props {
  Icon: OverridableComponent<SvgIconTypeMap<object, 'svg'>>;
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  mobileSize?: PLAYER_BUTTON_SIZE;
  isDisabled?: boolean;
}

const PlayerButton: React.FC<Props> = ({ Icon, onClick, mobileSize, isDisabled = false }) => {
  const StyledIcon = muiStyled(Icon)(() => ({
    shadowedIconStyle,
  }));

  return (
    <Button
      onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
        event.stopPropagation();
        if (!isDisabled) {
          onClick(event);
        }
      }}
      mobileSize={mobileSize}
      isDisabled={isDisabled}
    >
      <StyledIcon fontSize='inherit' color='inherit' />
    </Button>
  );
};

export default React.memo(PlayerButton);
